// Typed static client for the /DispenseError/* endpoints.
// All-static, returns typed data (never a raw AxiosResponse), rethrows errors.
// Follows the PrescriptionService precedent.
//
// URL note: axios.defaults.baseURL already ends in /api. The endpoint string here
// is preserved verbatim from PrescriptionDetailsPage.vue's original call site.

import axios from 'axios'
import { DispenseError } from '@/models/DispenseError'

export class DispenseErrorService {
    /** Mark a dispense error as resolved; returns the updated error. */
    static async resolve(dispenseErrorId: number): Promise<DispenseError> {
        const response = await axios.post<DispenseError>(`DispenseError/resolve/${dispenseErrorId}`)
        return response.data
    }
}
